module.exports = __webpack_public_path__ + "static/media/bitnovo.eae9c2e1.svg";